<template>
	<div class="form__field file-field" :class="`--${size}`">
		<div class="file-input-container">
			<label :for="name" class="label">
				<span>{{ label }}</span>
				<span v-if="required" class="required-symbol">*</span>
			</label>
			<input ref="input" class="file-input" type="file" :id="name" :name="name" @change="input"
				@focusout="handleFocusOut" @focusin="handleFocusIn" :multiple="multiple > 1" :accept="accept" />
			<label class="fake-file-input" :for="name">
				<span class="selected-file">{{ fileName }}</span>
				<span class="fake-button btn --white --border">{{ $t('form.label.select_file_single') }}</span>
			</label>
			<p v-if="message" class="note">{{ message }}</p>
			<p :class="['input-error', { '--hidden': !showError }]">
				{{ $t(`form.errors.${name}`) }}
			</p>
		</div>
		<div v-if="preview" class="file-preview bg-off">
			<img v-if="filePreview || fileUrl" :src="filePreview || fileUrl" alt="File preview" class="preview-image" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'FormFile',
	props: {
		label: {
			type: String,
			required: true
		},
		modelValue: {
			type: Object,
			required: true
		},
		size: {
			type: String,
			default: null
		},
		message: {
			type: String,
			default: null
		},
		name: {
			type: String,
			required: true
		},
		required: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Number,
			default: 1
		},
		accept: {
			type: String,
			default: null
		},
		preview: {
			type: Boolean,
			default: false
		},
		maxSize: {
			type: Number,
			default: 2048
		}
	},
	data() {
		return {
			hasFocusedIn: false,
			hasFocusedOut: false,
			selectedFiles: null,
			filePreview: null,
			showError: false
		}
	},
	methods: {
		handleFocusIn(e) {
			this.hasFocusedIn = true
			this.input(e)

			setTimeout(() => {
				const isValid = this.validate(e)

				if (this.hasFocusedOut && !isValid) {
					this.showError = true
				}
				else if (isValid) {
					this.showError = false
				}
			}, 500)
		},
		async handleFocusOut(e) {
			this.input(e)

			setTimeout(() => {
				this.hasFocusedOut = true
				const isValid = this.validate(e)

				if (!document.hasFocus() || isValid) {
					this.showError = false
				}

				if (document.hasFocus() && !isValid) {
					this.showError = true
				}
			}, 500)
		},
		input(event) {
			const files = event.target.files
			if (files && files[0]) {
				const file = files[0]

				const reader = new FileReader()

				reader.onload = (e) => {
					this.filePreview = e.target.result
				}
				reader.readAsDataURL(file)

				this.selectedFiles = files
			}

			this.$emit('update:modelValue', {
				file: event.target.files,
				previewName: !event.target.value ? this.modelValue.previewName : null,
				previewUrl: !event.target.value ? this.modelValue.previewUrl : null,
				value: event.target.value,
				valid: this.validate(event)
			})
		},
		validate(event) {
			let target = event.target

			let totalSize = 0
			if (target.files.length > 0) {
				for (let i = 0; i < target.files.length; i++) {
					let fSize = target.files.item(i).size / 1024

					totalSize += fSize
				}
			}

			if (target.value === '' && this.required === true) {
				return !!this.modelValue.previewName
			}

			if (totalSize >= this.maxSize) {
				return false
			}

			return target.files.length <= this.multiple
		}
	},
	computed: {
		fileName() {
			if (this.modelValue.previewName) return this.modelValue.previewName
			if (!this.selectedFiles || this.selectedFiles.length === 0) return ''


			return `(${this.selectedFiles.length}) ` + Array.from(this.selectedFiles).map(({ name }) => name).join(', ')
		},
		fileUrl() {
			if (this.modelValue.previewUrl) return this.modelValue.previewUrl
			if (!this.selectedFiles || this.selectedFiles.length === 0) return ''

			const file = this.selectedFiles[0]
			return file.url
		},
		stillInWebPage() {
			return document.hasFocus()
		}
	},
	emits: ['update:modelValue'],
	mounted() {
		this.$emit('update:modelValue', {
			file: '',
			previewName: this.modelValue.previewName || null,
			previewUrl: this.modelValue.previewUrl || null,
			value: '',
			valid: this.modelValue.previewName
		})
	}
}
</script>